import { render, staticRenderFns } from "./quiz-contest-popup.html?vue&type=template&id=36b0eb76&scoped=true&"
import script from "./quiz-contest-popup.js?vue&type=script&lang=js&"
export * from "./quiz-contest-popup.js?vue&type=script&lang=js&"
import style0 from "./quiz-contest-popup.scss?vue&type=style&index=0&id=36b0eb76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0eb76",
  null
  
)

export default component.exports